import React from 'react';
import styled from 'styled-components/macro';

import { ReactComponent as ToggleCaret } from 'icons/icon-toggle-caret.svg';
import { ReactComponent as SmallToggleCaret } from 'icons/small-caret.svg';

const ToggleCaretWrapper = (props: any): any => {
  const { children, isSmall, ...rest } = props;
  delete rest.isPointingUp;

  if (isSmall) return <SmallToggleCaret {...rest}>{children}</SmallToggleCaret>;
  return <ToggleCaret {...rest}>{children}</ToggleCaret>;
};

export default styled(ToggleCaretWrapper)`
  transform: ${({ isPointingUp }): string =>
    isPointingUp ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 300ms linear;
  color: inherit;
`;
